import { createContext, useContext } from "react";

export const MapContext = createContext(null);
export const SetMapContext = createContext(() => null);

export function useMap() {
  return useContext(MapContext);
}

export function useSetMap() {
  return useContext(SetMapContext);
}
